export default __webpack_public_path__ + "static/media/pagination_right_arrow_disabled.7f1570e7.svg";